export default "__VITE_ASSET__Bejg_uvI__"